enum AppSection {
    Main = '',
    Docs = 'Docs',
    Admin = 'Admin',
}

class LinkHash{
    LinkName: string
    Hash: string
    constructor(LinkName: string, Hash: string) {
        this.LinkName = LinkName;
        this.Hash = Hash;
    }
}

const SectionHooks: Record<AppSection, LinkHash[]> = {
    [AppSection.Main]: [new LinkHash("News", "#news"), new LinkHash("Nasze Plany", "#ourplans"), new LinkHash("O nas", "#aboutus"), new LinkHash("Dokumentacja", "#docs"), new LinkHash("Kontakt","#contact")],
    [AppSection.Docs]: [],
    [AppSection.Admin]: [],
}


export {AppSection, SectionHooks}